import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";
import { mapRentInventoryToServer } from "./mappers/mapRentInventoryToServer";

export const removeInventoryFromRent = async (sessionKey, rentInventory) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/remove/inventory`,
            method: "DELETE",
            data: mapRentInventoryToServer(rentInventory),
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
